import axios from "axios";
import { convertArgMapListToQueryString, getCookie } from "../../utils";
import { API_BASE_PATH } from "../../const";

const getCustomers = (args) => {
    const paramsString = convertArgMapListToQueryString(args)

    return axios
        .get(API_BASE_PATH + `customers/${paramsString}`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};


const getCustomerDetail = (args) => {
    
    return axios
        .get(API_BASE_PATH + `customers/${args.customerId}/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const createCustomer = (args) => {
    
    return axios
        .post(API_BASE_PATH + `customers/`, {
                ...args
            }, {
                headers: {
                    'X-CSRFToken': getCookie("csrftoken"),
                }
            })
            .then((response) => {
                return response.data;
            });
};

const updateCustomer = (customerId, args) => {
    
    return axios
        .patch(API_BASE_PATH + `customers/${customerId}/`, {
                ...args
            }, {
                headers: {
                    'X-CSRFToken': getCookie("csrftoken"),
                }
            })
            .then((response) => {
                return response.data;
            });
};

const addPaymentMethod = (customerId, args) => {
    return axios
        .post(API_BASE_PATH + `customers/${customerId}/add_payment_method/`, {
                ...args
            }, {
                headers: {
                    'X-CSRFToken': getCookie("csrftoken"),
                }
            })
            .then((response) => {
                return response.data;
            });
};

const addSubscription = (customerId, args) => {
    return axios
        .post(API_BASE_PATH + `customers/${customerId}/add_subscription/`, {
                ...args
            }, {
                headers: {
                    'X-CSRFToken': getCookie("csrftoken"),
                }
            })
            .then((response) => {
                return response.data;
            });
};




const customersService = {
    getCustomers,
    getCustomerDetail,
    createCustomer,
    updateCustomer,
    addPaymentMethod,
    addSubscription
};

export default customersService;